export const rrqs = new Map([
    ["2NDST", "2nd St."],
    ["3RDAVE", "3rd Ave."],
    ["6THST", "6th St."],
    ["ABERDN", "Aberdeen"],
    ["ANACOR", "Anacortes"],
    ["ANACRT", "Anacortes"],
    ["ANAFT2", "ANAFT2"],
    ["AURORA", "Aurora"],
    ["BOONE", "Boone St."],
    // ["BREFT2", "BREFT2"],
    ["BREMER", "Bremerton"],
    ["BROWNE", "Browne St."],
    ["BURKE", "Beverly Burke Rd."],
    ["CANBY", "Fort Canby"],
    ["CEDRWY", "Cedar Way"],
    ["CLEELM", "Cle Elem"],
    // ["CLIFT2", "CLIFT2"],
    ["CLINTN", "Clifton"],
    ["COLFAX", "Colfax"],
    ["COUGAR", "Cougar"],
    ["COUPLT", "COUPLT"],
    ["COUPVL", "Coupville"],
    ["CRWNPT", "Crown Point"],
    ["CS0631", "CS0631"],
    ["DIVISN", "Division"],
    ["EAGHBR", "Eagle Harbor"],
    ["EDMOND", "Edmonds"],
    ["EVERET", "Everett"],
    ["FAUNTL", "Fauntleroy"],
    ["FIFE", "Fife"],
    ["FRIDAY", "Friday Harbor"],
    ["GNESSE", "GNESSE"],
    ["GORST", "Gorst"],
    ["HERON", "Heron St."],
    ["HQUIAM", "Hoquiam"],
    ["HYAK", "Hyak Dr."],
    ["KELRNO", "Keller North"],
    ["KELRSO", "Keller South"],
    ["KELSO", "Kelso"],
    ["KINFT1", "KINFT1"],
    ["KINGST", "Kingston"],
    ["KNGSTN", "Kingston"],
    ["LEAHY", "Leahy"],
    ["LONNGR", "LONNGR"],
    ["LOPEZ", "Lopez"],
    ["MARYHL", "Maryhill"],
    ["MKLTEO", "Mukilteo"],
    ["MONROE", "Monroe"],
    ["MORA", "Mora Rd."],
    ["MTBAKR", "Mt. Baker"],
    ["MUKILT", "Mukilteo"],
    ["NEWPRT", "Newport"],
    ["NSC", "NSC"],
    ["OLD504", "Old 504"],
    ["OMAK", "Omak"],
    ["ORCAS", "Orcas Island"],
    ["ORGBEG", "ORGBEG"],
    ["ORGMID", "ORGMID"],
    ["ORGSPR", "ORGSPR"],
    ["ORONDO", "Orondo"],
    ["OSO", "Oso"],
    ["PAINE", "Paine"],
    ["PEARL", "Pearl St."],
    ["PRTANG", "Port Angeles"],
    ["PTDEFI", "Pt. Defiance"],
    ["PTTFT2", "PTTFT2"],
    ["PTTOWN", "Port Townsend"],
    ["PULLMN", "Pullman"],
    ["PURDY", "Purdy Ln."],
    ["REDMND", "Redmond"],
    // ["SEAFT2", "SEAFT2"],
    // ["SEAFT3", "SEAFT3"],
    ["SEATAC", "SeaTac"],
    ["SEATTL", "Seattle"],
    ["SHAW", "Shaw Island"],
    ["SIDNEY", "Sidney"],
    ["SLVRDL", "Silverdale"],
    ["SOUTHW", "Southworth"],
    ["SUMAS", "Sumas"],
    ["TAHLEQ", "Tahlequa"],
    ["TUNNEL", "Tunnel"],
    ["UNDRWD", "Underwood"],
    ["VANCVR", "Vancouver"],
    // ["VASFT2", "VASFT2"],
    ["VASHON", "Vashon"],
    ["VIADCT", "Alaskan Way Viaduct"],
    ["WALULA", "Wallula Junction"],
    ["WENTCH", "Wenatchee"],
    ["WESTPT", "Westport"],
    // ["WINFT2", "WINFT2"],
    ["WINSLO", "Winslow"],
    ["XBASE", "XBASE"],
    ["YELMLP", "Yelm Loop"]
]);
export default rrqs;
